angular.module('app.controllers').controller('ApplicationCtrl', ['$scope', '$route', '$rootScope', '$sce', '$interval', '$cookies', 'UI', '$location', '$timeout', 'APIData', 'APIForm', 'APIFile', '$http', 'APIExhibitor', 'APIEvent'].append(function(self, $route, root, $sce, $interval, $cookies, UI, $location, $timeout, APIData, APIForm, APIFile, $http, APIExhibitor, APIEvent) {
  var decode, params, ref;
  params = $location.search();
  self.trustAsResourceUrl = $sce.trustAsResourceUrl;
  self.trustAsHtml = function(string) {
    return $sce.trustAsHtml(string);
  };
  self.fake = {
    product_areas: [],
    logo: null,
    check1: false,
    check2: false,
    check3: false
  };
  if (angular.isDefined(params.hash)) {
    if (parseInt(params.hash) === 38110) {
      self.token = "Hf4p55mvz_1DLsxs2mBC";
      self.exhibitor_id = 38110;
    } else {
      decode = ((ref = atob(params.hash)) != null ? ref.split("|") : void 0) || [];
      self.token = decode[2] || null;
      self.exhibitor_id = decode[1] || null;
    }
    if ((self.token != null) && (self.exhibitor_id != null)) {
      APIData.get({
        exhibitor_id: self.exhibitor_id,
        auth_token: self.token
      }, function(data) {
        var ref1, ref2, ref3;
        self.data = Object.values(data).length > 2 ? data : null;
        if ((ref1 = self.data) != null ? ref1.area : void 0) {
          self.data.area = parseInt(self.data.area);
        }
        return self.fake.product_areas = ((ref2 = self.data) != null ? (ref3 = ref2.product_areas) != null ? ref3.split(",").filter(Boolean) : void 0 : void 0) || [];
      }, function(response) {
        return UI.notify(false, response.data.error);
      });
    }
  }
  self.saveForm = function(slug, form) {
    return self[slug] = form;
  };
  self.formProccess = false;
  self.formSuccess = false;
  
  // Contact Modal

  self.hideContactModal = function() {
    self.formProccess = false;
    self.formSuccess = false;
    self.cForm.$setPristine();
    return self.cForm.$setUntouched();
  };
  self.showContactModal = function() {
    self.formProccess = false;
    self.fake.check1 = false;
    self.fake.check2 = false;
    self.fake.check3 = false;
    return self.cdata = {
      company: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      message: ""
    };
  };
  self.contactModalEl = document.getElementById('modalContacts');
  if (self.contactModalEl) {
    self.contactModal = bootstrap.Modal.getOrCreateInstance(self.contactModalEl);
    self.contactModalEl.addEventListener('hidden.bs.modal', function(event) {
      self.hideContactModal();
      return self.$applyAsync();
    });
    self.contactModalEl.addEventListener('shown.bs.modal', function(event) {
      self.showContactModal();
      return self.$applyAsync();
    });
  }
  self.contact = function() {
    self.formProccess = true;
    return (new APIForm(self.cdata)).$save({}, function(data) {
      if (data.success) {
        self.showContactModal();
        self.formSuccess = data.success;
      }
      self.cForm.$setPristine();
      return self.cForm.$setUntouched();
    }, function(response) {
      self.formProccess = false;
      return UI.notify(false, response.data.error);
    });
  };
  
  // Registration Modal

  self.areasChanged = function() {
    return self.data.product_areas = self.fake.product_areas.join(",");
  };
  self.step = 1;
  self.setStep = function(next = true) {
    if (self.step === 3 && next) {
      return self.register();
    }
    if (self.step === 1 && !next) {
      return false;
    }
    if (next) {
      self.step++;
    }
    if (!next) {
      return self.step--;
    }
  };
  self.hideRegModal = function() {
    self.formProccess = false;
    self.formSuccess = false;
    self.rForm1.$setPristine();
    self.rForm1.$setUntouched();
    self.rForm2.$setPristine();
    self.rForm2.$setUntouched();
    self.rForm3.$setPristine();
    self.rForm3.$setUntouched();
  };
  self.showRegModal = function() {
    self.formProccess = false;
    self.step = self.data.registered && parseInt(params != null ? params.hash : void 0) !== 38110 ? 5 : 1;
  };
  self.regModalEl = document.getElementById('modalReg');
  if (self.regModalEl) {
    self.regModal = bootstrap.Modal.getOrCreateInstance(self.regModalEl);
    self.regModalEl.addEventListener('hidden.bs.modal', function(event) {
      self.hideRegModal();
      return self.$applyAsync();
    });
    self.regModalEl.addEventListener('show.bs.modal', function(event) {
      if (self.data == null) {
        return event.preventDefault();
      }
      self.showRegModal();
      return self.$applyAsync();
    });
  }
  return self.register = function() {
    var fd;
    self.formProccess = true;
    self.data.registered = true;
    if (self.fake.logo) {
      fd = new FormData();
      fd.append('logofile', true);
      fd.append('file', self.fake.logo);
      return $http.post("api.php?path=/exhibitor_data/upload&_private=true&auth_token=" + self.token, fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': void 0
        }
      }).then(function(response) {
        self.data.logo = response.data;
        return self.data.$update({
          exhibitor_id: self.exhibitor_id,
          auth_token: self.token
        }, function(data) {
          self.formProccess = false;
          self.formSuccess = true;
          (new APIFile(data)).$save({});
          APIEvent.get({
            auth_token: self.token,
            _entry: 'ticket',
            role: 's'
          }, function(data) {
            var ref1;
            return (new APIExhibitor({
              is_visible: true
            })).$update({
              ticket_id: ((ref1 = data.service_tickets.exhibitor) != null ? ref1.ticket_id : void 0) || null,
              _entry: 'visibility'
            });
          });
          return self.step = 4;
        }, function(response) {
          self.formProccess = false;
          return UI.notify(false, response.data.error);
        });
      }, function(response) {
        self.formProccess = false;
        return UI.notify(false, response.data.error);
      });
    } else {
      return self.data.$update({
        exhibitor_id: self.exhibitor_id,
        auth_token: self.token
      }, function(data) {
        self.formProccess = false;
        self.formSuccess = true;
        (new APIFile(data)).$save({});
        APIEvent.get({
          auth_token: self.token,
          _entry: 'ticket',
          role: 's'
        }, function(data) {
          var ref1;
          return (new APIExhibitor({
            is_visible: true
          })).$update({
            ticket_id: ((ref1 = data.service_tickets.exhibitor) != null ? ref1.ticket_id : void 0) || null,
            _entry: 'visibility'
          });
        });
        return self.step = 4;
      }, function(response) {
        self.formProccess = false;
        return UI.notify(false, response.data.error);
      });
    }
  };
}));
